import Popover from 'trunks/vue/admin/components/libs/popover.js';
import { HeaderFieldCellMixins, FieldCellMixins, HeaderRangeFieldCellMixins } from './mixins.js';
import DateTimeFieldMixins from 'trunks/vue/admin/mixins/datetime_field.js';
import DateTimePickerPopover from 'trunks/vue/admin/components/date_time_picker_popover.js';

const FILTER_LIST = [
  {
    text: '截至目前',
    value: {
      lft: '',
      rgt: '1d'
    }
  },
  {
    text: '本周星期一至星期五',
    value: {
      lft: '1w1',
      rgt: '1w5'
    }
  },
  {
    text: '本月1日至最后1日',
    value: {
      lft: '1m1',
      rgt: '1m-1'
    }
  },
  {
    text: '过去3天～今天',
    value: {
      lft: '-3d',
      rgt: '1d'
    }
  },
  {
    text: '过去7天～今天',
    value: {
      lft: '-7d',
      rgt: '1d'
    }
  },
  {
    text: '过去30天～今天',
    value: {
      lft: '-30d',
      rgt: '1d'
    }
  },
  {
    text: '过去90天～今天',
    value: {
      lft: '-90d',
      rgt: '1d'
    }
  }
];

const HoldCreatedAtCell = {
  mixins: [FieldCellMixins],

  template: `
    <span :title='text_value'>{{ text_value }}</span>
  `,

  computed: {
    text_value: function() {
      if (this.entries[0]) {
        return new Date(this.entries[0].value).strftime('YYYY-MM-DD hh:mm:ss');
      } else {
        return '';
      }
    }
  }
};

const DateTimeHeaderCell = {
  mixins: [
    HeaderFieldCellMixins,
    HeaderRangeFieldCellMixins,
    DateTimeFieldMixins
  ],

  components: {
    popover: Popover,
    'datetime-picker': DateTimePickerPopover
  },

  props: {
    filterList: {
      type: Array,
      default: function() {
        return FILTER_LIST;
      }
    }
  },

  data: function() {
    return {
      customRange: null,
      rangeType: 'static',
      quickRange: null
    };
  },

  template: `
    <div class="filter-field-popover">
      <div class="filter-params-container">
        <div class="form-control">
          <div class="form-control-label">快速筛选</div>
          <div class="button-container">
            <button class="btn-default filter-btn btn-small"
                    v-for="(filter, index) in filterList"
                    @click="quickRangeClicked(filter)"
                    :class="quickRangeButtonClass(filter)">
              <span>{{ filter.text }}</span>
            </button>
          </div>
        </div>
      </div>
      <div class="filter-params-container">
        <div class="form-control">
          <div class="form-control-label">自定义筛选</div>
          <datetime-picker position='bottom'
                           :initValue='customRange'
                           :viewMode='viewMode'
                           :blockContent='false'
                           :modeChangeable='viewChangable'
                           :rangable='true'
                           @valueChanged='updateCustomRange'
                           ref='picker' />
        </div>
      </div>
      <div v-if="hasSort" class="sort-option-container list">
        <div class="list-item"
             v-for="sort in sortable"
             @click='toggleSort(sort)'
             :key='sort'>
          <div class="content">{{ Skylark.Helpers.getZH_CN('sort.' + sort) }}排列</div>
          <div class="tip" v-if='sorter === sort'>
            <i class="slp-check"></i>
          </div>
        </div>
      </div>
    </div>
  `,

  created: function() {
    this.$watch('customRange', function(new_value) {
      if (!new_value) {
        this.$refs.picker?.rangeReset();
      }
      this.start = this._getRange('start');
      this.end = this._getRange('end');
    }, { sync: true });
  },

  methods: {
    quickRangeButtonClass: function(filter) {
      if (this.quickRange === filter) {
        return 'outlined';
      } else {
        return 'link-btn';
      }
    },

    getFilter: function() {
      var _result;

      if (this.quickRange) {
        _result = {
          lft: this.quickRange.value.lft,
          rgt: this.quickRange.value.rgt,
          dynamic: true
        };
      } else {
        if (!(this.start || this.end)) {
          return null;
        }
        _result = {
          lft: this.start,
          rgt: this.end
        };
        if (this.rangeType === 'static') {
          _.each(_.keys(_result), (key) => {
            _result[key] = this._stringfy(_result[key]);
          });
        }
        if (this.rangeType === 'dynamic') {
          _result.dynamic = true;
        }
      }
      _.each(_result, (value, key) => {
        if (!value) {
          delete _result[key];
        }
      });
      return _result;
    },

    resetFilter: function() {
      if (this.filter.value) {
        if (this.quickRange) {
          this.customRange = null;
        } else {
          this.quickRange = null;
        }
      } else {
        this.customRange = null;
        this.quickRange = null;
      }
    },

    updateCustomRange: function(value, type) {
      this.customRange = value;
      this.rangeType = type;
      this.quickRange = null;
      this._emitChange();
    },

    quickRangeClicked: function(filter) {
      this.quickRange = filter;
      if (this.start || this.end) {
        this.customRange = null;
      }
      this._emitChange();
    },

    _getRange: function(position) {
      var _result;

      _result = this.customRange?.[position];
      if (!_result) {
        return;
      }
      if (this.rangeType === 'dynamic' && _result?.split(' ')[0].trim() === 'null') {
        return null;
      }
      return _result;
    }
  }
};

export {
  HoldCreatedAtCell,
  HoldCreatedAtCell as YAW__JourneyCreatedAtCell
};

export {
  DateTimeHeaderCell,
  DateTimeHeaderCell as HoldCreatedAtHeaderCell,
  DateTimeHeaderCell as YAW__JourneyCreatedAtHeaderCell
};
